import { isNonEmptyArray, ensureArray } from 'utils/arrays';

const initialState = {
  modalType: null,
  modalProps: {},
  stackedModals: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ROOT/SHOW_MODAL': {
      const modalData = {
        modalType: action.modalType,
        modalProps: action.modalProps,
      };
      if (action.options.stacked) {
        // Prevents same modal from being opened on top of itself
        const currentStackedModals = ensureArray(state.stackedModals).filter(
          modal => modal.modalType !== modalData.modalType,
        );

        return {
          stackedModals: [...currentStackedModals, modalData],
        };
      }
      return modalData;
    }
    case 'ROOT/HIDE_MODAL': {
      if (isNonEmptyArray(state.stackedModals)) {
        return {
          stackedModals: state.stackedModals.filter(
            modal => modal.modalType !== action.modalType,
          ),
        };
      }
      return initialState;
    }
    case 'ROOT/REFRESH_MODAL_PROPS':
      if (isNonEmptyArray(state.stackedModals)) {
        return {
          stackedModals: state.stackedModals.map(modal => {
            if (action.modalType === modal.modalType) {
              return { ...modal, modalProps: action.modalProps };
            }
            return modal;
          }),
        };
      }
      return {
        ...state,
        modalProps: {
          ...state.modalProps, // @NOTE do not remove. This retains reference to `resetProps` function
          ...action.modalProps,
        },
      };
    default:
      return state;
  }
};
